import { actions } from 'actions/labels';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  initialized: false,
  error: null
};

const labels = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actions.fetchLabels:
      return {
        ...state,
        fetching: true
      };
    case actions.fetchLabelsSuccess:
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: payload
      };
    case actions.fetchLabelsError:
      return {
        ...state,
        fetching: false,
        error: payload
      };
    case actions.initLabels:
      return {
        ...state,
        initialized: true
      };
    default:
      return state;
  }
};

export default labels;



// WEBPACK FOOTER //
// ./src/reducers/labels.js